import React, { useCallback } from "react";
import moment from "moment";
import Image from "next/image";
import MUIDataTable from "mui-datatables";
import { Button } from "reactstrap";

import { AvailableRate } from "@/@types/Rating/AvailableRate";
import { compareByPrice } from "@/utils/ratingUtils";
import InformationTooltip from "../utils/information-tooltip";
import { carrierLogosUrl } from "@/utils/images";
import RateDetailsPopover from "../utils/rate-details-popover";

interface ChooseServiceTableProps {
  availableRates: AvailableRate[];
  tableTitle: string;
  handleChooseRate: () => void;
}
const ChooseServiceTable = ({
  tableTitle,
  availableRates,
  handleChooseRate,
}: ChooseServiceTableProps) => {
  const ratesPre = [...availableRates].sort(compareByPrice);

  const formatArrivalDateTime = useCallback(
    (arrivalDate: string, arrivalTime: string) => {
      if (!arrivalTime) {
        return;
      }

      const times = [
        arrivalTime.substring(0, 2),
        arrivalTime.substring(2, 4),
        arrivalTime.substring(4, 6),
      ];

      return `${moment(arrivalDate).format("YYYY-MM-DD")} ${times[0]}:${
        times[1]
      }:${times[2]}`;
    },
    []
  );

  const handleButtonClick = useCallback(
    (carrierName: string) => {
      if (carrierName === "SHIPVISTACONNECT") {
        window.location.href = "/partners/shipvista-connect";
      } else {
        handleChooseRate();
      }
    },
    [handleChooseRate]
  );

  const columns = [
    {
      options: { display: false },
      name: "id",
    },
    {
      options: { display: false },
      name: "carrierName",
    },
    {
      options: { display: false },
      name: "arrivalTime",
    },
    {
      options: { display: false },
      name: "arrivalDate",
    },
    {
      name: "transitDay",
      label: "Transit Day",
      options: {
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>
                {value
                  ? `${value} ${value === 1 ? "day" : "days"}`
                  : `Time Not Guarantee`}
              </div>
              <div
                style={{
                  fontSize: "0.8rem",
                  fontStyle: "italic",
                  color: "#3c8dbc",
                }}
              >
                {value &&
                  tableMeta.rowData[3] &&
                  tableMeta.rowData[2] &&
                  formatArrivalDateTime(
                    tableMeta.rowData[3],
                    tableMeta.rowData[2]
                  )}
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "account",
      label: "Account Nickname",
      options: {
        sort: false,
        customBodyRender: (value: any) => value?.name,
      },
    },
    {
      name: "service",
      label: "Carrier",
      options: {
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              <Image
                alt={`${tableMeta.rowData[1]} Logo`}
                src={
                  value?.serviceName !== "SV Big Savings"
                    ? `${carrierLogosUrl}${tableMeta.rowData[1]?.toLowerCase()}.png`
                    : `/logoShipvista.png`
                }
                width={25}
                height={25}
              />
              &nbsp;&nbsp;
              {value?.serviceName !== "SV Big Savings"
                ? tableMeta.rowData[1]
                : "SV Select"}
            </>
          );
        },
      },
    },
    {
      name: "shippingService",
      label: "Service",
      options: {
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {tableMeta.rowData[6].serviceName} &nbsp;
              {/* {value && value.isSaturdayDelivery && (
                <InformationTooltip
                  message={value.saturdayDeliveryDisclaimer}
                />
              )} */}
            </>
          );
        },
      },
    },
    {
      name: "price",
      label: "Price ($)",
      options: {
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              <RateDetailsPopover
                rate={value}
                id={`rate${tableMeta.rowIndex}${tableMeta.columnIndex}`}
                service={tableMeta.rowData[6]}
                account={tableMeta.rowData[5]}
                carrierName={tableMeta.rowData[1]}
              />
            </>
          );
        },
      },
    },
    {
      name: "Action",
      label: "Action",
      options: {
        sort: false,
        customBodyRender: (_value: any, tableMeta: any) => {
          const carrierName = tableMeta.rowData[1] as string;
          const buttonText =
            carrierName === "SHIPVISTACONNECT" ? "Learn More" : "Ship Now";

          return (
            <Button
              variant="contained"
              className="btn-darkBlue text-uppercase btn-sm"
              onClick={() => handleButtonClick(carrierName)}
            >
              {buttonText}
            </Button>
          );
        },
      },
    },
  ];

  const options = {
    // filterType: "checkbox",
    print: false,
    download: false,
    viewColumns: false,
    filter: false,
    search: false,
    selectableRowsHideCheckboxes: true,
  };

  return (
    <div>
      <div>
        <MUIDataTable
          title={""}
          data={ratesPre}
          columns={columns}
          options={options}
        />
      </div>
    </div>
  );
};

export default ChooseServiceTable;
